const daysOfWeek = {
    es: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
const monthsOfYearAbbreviations = {
    es: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};
const monthsOfYear = {
    es: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};

function formatDate(dateString, language) {
    const date = new Date(dateString);
    const dayOfWeek = daysOfWeek[language][date.getUTCDay()];
    const day = date.getUTCDate();
    const month = monthsOfYearAbbreviations[language][date.getUTCMonth()];
    return {
        dayOfWeek: dayOfWeek,
        dayAndMonth: language === 'es' ? `${day} ${month}` : `${month} ${day}`
    };
}


function calculateDateDifference(checkin, checkout) {
    const checkinDate = new Date(checkin);
    const checkoutDate = new Date(checkout);
    const differenceInTime = checkoutDate - checkinDate;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
}

export { daysOfWeek, monthsOfYear, formatDate, calculateDateDifference };